module.exports = __webpack_public_path__ + "static/media/snagshout-merchant-logo.ad4c2313.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/snagshout-merchant-logo.png
// module id = 2006
// module chunks = 23